import { Card, CardContent } from '@/components/ui/card';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function TermsOfService() {
  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4">
      <div className="max-w-4xl mx-auto">
        <Link to="/" className="inline-flex items-center text-blue-600 hover:text-blue-700 mb-6">
          <ArrowLeft className="w-4 h-4 mr-2" />
          Torna indietro
        </Link>
        
        <Card>
          <CardContent className="p-8 prose max-w-none">
            <h1 className="text-3xl font-bold text-gray-900 mb-6">Termini e Condizioni del Servizio</h1>
            <p className="text-sm text-gray-600 mb-8">Ultimo aggiornamento: Novembre 2025</p>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">1. Oggetto</h2>
            <p className="text-gray-700 mb-4">
              I presenti Termini e Condizioni regolano l'utilizzo della piattaforma ZonePass, 
              servizio di biglietteria elettronica per eventi.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">2. Definizioni</h2>
            <ul className="list-disc pl-6 text-gray-700 mb-4">
              <li><strong>Piattaforma:</strong> Il servizio ZonePass accessibile via web e app mobile</li>
              <li><strong>Organizzatore:</strong> Soggetto che crea e gestisce eventi sulla piattaforma</li>
              <li><strong>Acquirente:</strong> Soggetto che acquista biglietti tramite la piattaforma</li>
              <li><strong>Biglietto:</strong> Titolo di accesso all'evento in formato digitale con QR code</li>
            </ul>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">3. Registrazione Organizzatori</h2>
            <p className="text-gray-700 mb-4">
              Per utilizzare la piattaforma come organizzatore è necessario:
            </p>
            <ul className="list-disc pl-6 text-gray-700 mb-4">
              <li>Avere almeno 18 anni o agire per conto di persona giuridica</li>
              <li>Fornire dati veritieri e completi</li>
              <li>Mantenere riservate le credenziali di accesso</li>
              <li>Fornire dati fiscali validi per fatturazione</li>
            </ul>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">4. Obblighi dell'Organizzatore</h2>
            <p className="text-gray-700 mb-4">L'organizzatore si impegna a:</p>
            <ul className="list-disc pl-6 text-gray-700 mb-4">
              <li>Creare eventi reali e leciti</li>
              <li>Fornire informazioni accurate sull'evento</li>
              <li>Rispettare le normative vigenti</li>
              <li>Gestire i rimborsi secondo le proprie policy</li>
              <li>Non utilizzare la piattaforma per attività illecite</li>
              <li>Garantire la privacy degli acquirenti secondo GDPR</li>
            </ul>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">5. Gestione Pagamenti e Responsabilità</h2>
            <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 mb-4">
              <p className="text-yellow-800 font-semibold mb-2">IMPORTANTE - DISCLAIMER PAGAMENTI:</p>
              <ul className="list-disc pl-6 text-yellow-800">
                <li><strong>ZonePass NON gestisce i pagamenti dei biglietti.</strong></li>
                <li><strong>I pagamenti vanno DIRETTAMENTE all'organizzatore</strong> tramite il metodo da lui configurato (IBAN, PayPal, Stripe).</li>
                <li><strong>ZonePass non è responsabile degli eventi organizzati</strong> né della loro esecuzione.</li>
                <li><strong>ZonePass non è responsabile dei rimborsi</strong>. Eventuali rimborsi sono a discrezione dell'organizzatore.</li>
                <li>ZonePass fornisce SOLO la piattaforma tecnologica per la gestione biglietti e check-in.</li>
              </ul>
            </div>
            
            <p className="text-gray-700 mb-4">
              <strong>Responsabilità Organizzatore:</strong> L'organizzatore è il solo responsabile per:
            </p>
            <ul className="list-disc pl-6 text-gray-700 mb-4">
              <li>La raccolta dei pagamenti dai clienti</li>
              <li>La gestione delle richieste di rimborso</li>
              <li>L'esecuzione dell'evento come descritto</li>
              <li>Il rispetto delle normative fiscali e di sicurezza</li>
              <li>La comunicazione con i partecipanti</li>
            </ul>
            
            <p className="text-gray-700 mb-4">
              <strong>Commissioni ZonePass:</strong> Per l'utilizzo della piattaforma, ZonePass applica commissioni variabili in base al piano sottoscritto. Le commissioni vengono addebitate separatamente e NON influenzano i pagamenti dei biglietti.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">6. Biglietti</h2>
            <p className="text-gray-700 mb-4">
              I biglietti sono emessi in formato digitale con QR code univoco. L'acquirente è responsabile della 
              custodia del biglietto. In caso di smarrimento, contattare l'organizzatore.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">7. Rimborsi e Cancellazioni</h2>
            <p className="text-gray-700 mb-4">
              I rimborsi sono gestiti dall'organizzatore secondo le sue policy. ZonePass non è responsabile 
              dei rimborsi, ma fornisce gli strumenti tecnici per gestirli.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">8. Limitazioni di Responsabilità</h2>
            <p className="text-gray-700 mb-4">
              ZonePass fornisce la piattaforma tecnologica ma non è responsabile per:
            </p>
            <ul className="list-disc pl-6 text-gray-700 mb-4">
              <li>Contenuto e veridicità delle informazioni sugli eventi</li>
              <li>Cancellazioni o modifiche eventi da parte dell'organizzatore</li>
              <li>Esperienze negative durante l'evento</li>
              <li>Problemi tecnici non dipendenti dalla piattaforma</li>
            </ul>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">9. Proprietà Intellettuale</h2>
            <p className="text-gray-700 mb-4">
              Tutti i diritti sulla piattaforma, logo, design e codice sono di proprietà di ZonePass. 
              Gli organizzatori mantengono i diritti sui propri contenuti.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">10. Sospensione e Chiusura Account</h2>
            <p className="text-gray-700 mb-4">
              ZonePass si riserva il diritto di sospendere o chiudere account in caso di:
            </p>
            <ul className="list-disc pl-6 text-gray-700 mb-4">
              <li>Violazione dei presenti termini</li>
              <li>Attività fraudolente o illecite</li>
              <li>Mancato pagamento delle commissioni</li>
              <li>Comportamenti dannosi verso altri utenti</li>
            </ul>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">11. Modifiche ai Termini</h2>
            <p className="text-gray-700 mb-4">
              Ci riserviamo il diritto di modificare i presenti termini. Le modifiche saranno comunicate 
              via email e pubblicate su questa pagina. L'uso continuato della piattaforma costituisce 
              accettazione delle modifiche.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">12. Legge Applicabile e Foro</h2>
            <p className="text-gray-700 mb-4">
              I presenti termini sono regolati dalla legge italiana. Per ogni controversia è competente 
              il Foro di [Città].
            </p>

            <div className="bg-blue-50 border border-blue-200 rounded-lg p-6 mt-8">
              <p className="text-sm text-blue-900">
                <strong>Contatti:</strong><br/>
                Email: support@zonepass.io<br/>
                Telefono: +39 [Numero]<br/>
                Indirizzo: [Indirizzo completo]
              </p>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}